(function (UX) {
    'use strict';

    let showRecommended = {
        selectors: {
            placeholder: '.show-recommended-placeholder',
        },
        desktopWidth: 768,
        init: () => {
            let relatedTab;
            $(showRecommended.selectors.placeholder).each((index, widget) => {
                if (
                    $(widget).closest('#pane-pcw-related:not(.active)').length &&
                    window.screen.width >= showRecommended.desktopWidth
                ) {
                    relatedTab = document.querySelectorAll('#pane-pcw-related, #pane-pcw-relatedcon');
                    relatedTab.forEach(tab => {
                        tab.addEventListener('click', () => showRecommended.getRecommendedData(widget));
                    });
                } else {
                    showRecommended.getContent(widget);
                }
            });
        },
        getContent: widget => {
            let $widget = $(widget);
            $widget.load($widget.attr('data-ajaxurl'), 'onload=true', function () {
                showRecommended.truncate && showRecommended.truncate($widget);
                setTimeout(() => {
                    showRecommended.checkIfClosed($widget);
                    showRecommended.hideSkeletons($widget);
                    $(document).trigger('showRecommended:loaded');
                }, 10);
            });
        },
        getRecommendedData: widget => {
            if (!widget.classList.contains('js-reommended-loaded')) {
                showRecommended.getContent(widget);
                widget.classList.add('js-reommended-loaded');
            }
        },
        truncate: $widget => {
            if (!showRecommended.truncate) {
                return;
            }
            $('.creative-work__title', $widget).not("[data-truncate='none']").truncate({
                lines: 3,
                addClass: 'min-height',
            });

            $('.creative-work .loa', $widget).not("[data-truncate='none']").truncate({
                lines: 2,
                type: 'list',
                addClass: 'loa-height',
            });
        },
        checkIfClosed: $widget => {
            let $accordionTab = $widget.closest('.accordion-tabbed__tab');
            if (!$accordionTab.hasClass('js--open')) {
                $accordionTab.find('.accordion-tabbed__control').attr('aria-expanded', 'false');
                $accordionTab.find('.accordion-tabbed__content').hide();
            }
        },
        hideSkeletons: $widget => {
            $('.lazy-load', $widget).remove();
            $('.delayLoad', $widget).removeClass('delayLoad').addClass('delayedLoad');
            $widget.replaceWith($widget.children());
        },
    };
    UX.showRecommended = showRecommended;
})(UX);
